import React from "react";
import ResourcesContainer from "containers/ResourcesContainer";
import { shortLinkCheckoutPreview } from "components/FormerEditor/common/preview";
import CheckoutDetails from "../CheckoutDetails";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import HoverIconButton from "components/HoverIconButton";
import { secondaryBackButton } from "utils/constants/ui";
import { STATE_KEYS } from "utils/constants/state";
import { useFormikContext } from "formik";
import { composeCheckoutConfigsToShortLink } from "utils/checkout/merge";

const CheckoutResult = ({ name, checkout }) => {
  const commonCheckoutPath = `${name}.${STATE_KEYS.PRODUCT_COLLECTION.CONFIG_CHECKOUT_COMMON}`;
  const { values } = useFormikContext();
  const common = get(values, commonCheckoutPath);

  return (
    <ResourcesContainer>
      {({ products, prices, coupons, taxRates, shippingRates }) => {
        let content = null;

        if (!isEmpty(checkout)) {
          const checkoutPreview = shortLinkCheckoutPreview({
            shortLink: composeCheckoutConfigsToShortLink({
              selectedCheckout: checkout,
              commonConfig: common
            }),
            products,
            prices,
            coupons,
            taxRates,
            shippingRates
          });

          content = (
            <CheckoutDetails
              collapseImages={checkoutPreview.collapseImages}
              {...checkoutPreview.checkout}
            />
          );
        } else {
          const buttonProps = secondaryBackButton({
            type: "right"
          });
          content = (
            <div className="flex flex-row justify-between items-center">
              <div className="f6 fw5">Select products</div>
              <HoverIconButton {...buttonProps} />
            </div>
          );
        }

        return content;
      }}
    </ResourcesContainer>
  );
};

export default CheckoutResult;
